export default __webpack_public_path__ + "assets/images/97b8134e9130c8e3a3dc461061b54832.png";